type CubicBezier = [number, number, number, number]

export const MOTION_DURATION = {
  fast: 0.15,
  standard: 0.2,
  emphasis: 0.3,
  reveal: 0.4,
  overlay: 0.5,
  audioLoopFast: 0.8,
  audioLoopStandard: 1,
  audioLoopSlow: 1.5,
} as const

const MOTION_DELAY = {
  short: 0.1,
  staged: 0.15,
  standard: 0.2,
  emphasis: 0.3,
  long: 0.4,
} as const

export const MOTION_STAGGER = {
  compact: 0.06,
  standard: 0.08,
  relaxed: 0.1,
} as const

export const MOTION_EASE: Record<'standard' | 'emphasis', CubicBezier> = {
  standard: [0.4, 0, 0.2, 1],
  emphasis: [0.32, 0.72, 0, 1],
}

export const MOTION_SPRING = {
  drawer: { type: "spring", duration: 0.5, bounce: 0.2 },
} as const

export const MOTION_REPEAT = {
  loop: Number.POSITIVE_INFINITY,
} as const

const MOTION_COUNTER_DURATION_MS = {
  heroStat: 1200,
} as const
